import React, { useEffect, useState, useRef } from "react";
import "./styles.css";
import { CgSearch } from "react-icons/cg";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Slider from "react-slider";
import { BsSliders } from "react-icons/bs";
import ResponsiveFilterSection from "./ResponsiveFilterSection";
import axios from "axios";
import { BASE_URL } from "../../constant";
import { Link } from "react-router-dom";

const SortMenuComponent = ({
  setSelectedCategory,
  setCurrentProducts,
  setNavigatedCategory,
  searchTerm,
  onSearch,
  values,
  setValues,
  sortByAlphabatically,
  setSortByAlphabatically,
  stockStatus,
  setStockStatus,
  currentSubcategory,
  setCurrentSubcategory,
  scheme,
  setScheme,
  shape,
  setShape,
  openingCategory,
  setOpeningCategory,

  categories,
  colors,
  sizes,
  brands,
  minPrice,
  maxPrice,
  tempValues,
  setTempValues,
  setMaxPrice,
  isFiltered,
  setIsFiltered,
}) => {
  const offcanvasRef = useRef(null);
  const [isSortOpen, setIsSortOpen] = useState(false);

  const [dropdownStates, setDropdownStates] = useState({});

  useEffect(() => {
    if (!isFiltered) {
      axios
        .get(`${BASE_URL}/api/customProducts/all`)
        .then((response) => {
          const products = response.data;
          const prices = products.map((product) => product.productRate);
          const highestPrice = Math.max(...prices);
          setMaxPrice(highestPrice);
          setTempValues([minPrice, highestPrice]);
        })
        .catch((error) => {
          console.error("Error fetching product list:", error);
        });
    }
  }, [isFiltered]);

  const handleDropdownToggle = (categoryName) => {
    setDropdownStates((prevState) => ({
      ...prevState,
      [categoryName]: !prevState[categoryName],
    }));
  };

  const handleSubcategoryClick = (subCategoryId) => {
    setOpeningCategory("");
    setCurrentSubcategory(subCategoryId);
  };

  const handleStockStatusChange = (status) => {
    setStockStatus(status);
  };

  const toggleSortDropdown = () => {
    setIsSortOpen(!isSortOpen);
  };

  const handleSearchChange = (event) => {
    onSearch(event.target.value);
  };

  const handleSchemeChange = (selectedscheme) => {
    if (scheme == selectedscheme) {
      setScheme("");
    } else {
      setScheme(selectedscheme);
    }
  };

  const handleShape = (selectedshape) => {
    if (selectedshape == shape) {
      setShape("");
    } else {
      setShape(selectedshape);
    }
  };

  // useEffect(() => {
  //   setMinPrice(values[0]);
  //   setMaxPrice(values[1]);
  // }, [values]);

  // Fetch categories from the API

  useEffect(() => {
    if (offcanvasRef.current) {
      const offcanvas = window.bootstrap.Offcanvas.getInstance(
        offcanvasRef.current
      );
      if (offcanvas) offcanvas.hide();
    }
  }, [stockStatus, sortByAlphabatically, scheme, shape, currentSubcategory]);

  useEffect(() => {
    if (offcanvasRef.current) {
      const offcanvas = new window.bootstrap.Offcanvas(offcanvasRef.current);
      offcanvas.hide();
    }
  }, [offcanvasRef]);

  const handleClickApply = () => {
    setValues(tempValues);
    setIsFiltered(true); // Mark as filtered
    // fetchFilteredProducts(tempValues[0], tempValues[1]);
  };

  // const fetchFilteredProducts = (min, max) => {
  //   axios
  //     .get(
  //       `${BASE_URL}/api/customProducts/filterByPrice?minPrice=${min}&maxPrice=${max}`
  //     )
  //     .then((response) => {
  //       setCurrentProducts(response.data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching filtered products:", error);
  //     });
  // };

  return (
    <div>
      <div className="search ">
        <div className="search-container">
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <div className="search-bar-icon">
            <CgSearch size={25} />
          </div>
        </div>
        <div className="view-type">
          <div className="sort-container">
            <button
              className="d-flex align-items-center gap-2"
              style={{
                background: "none",
                fontWeight: "bold",
                fontSize: "20px",
                border: "none",
              }}
              onClick={toggleSortDropdown}
            >
              Filter by
              {isSortOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
            </button>
            {isSortOpen && (
              <div className="sort-menu">
                <div className="checkbox-container mt-1">
                  <h6 style={{ fontSize: "16px", fontWeight: "bold" }}>
                    <input
                      type="checkbox"
                      style={{ height: "15px", width: "15px" }}
                      checked={stockStatus === "inStock"}
                      onChange={() => handleStockStatusChange("inStock")}
                    />{" "}
                    In Stock
                  </h6>
                  <h6 style={{ fontSize: "16px", fontWeight: "bold" }}>
                    <input
                      style={{ height: "15px", width: "15px" }}
                      type="checkbox"
                      checked={stockStatus === "outOfStock"}
                      onChange={() => handleStockStatusChange("outOfStock")}
                    />{" "}
                    Out of Stock
                  </h6>
                </div>
                <div className="price-slider-container">
                  <Slider
                    className={"price-slider"}
                    value={tempValues}
                    min={minPrice}
                    max={maxPrice}
                    onChange={setTempValues}
                  />
                  <div className={"range-values"}>
                    <span>Rs.{tempValues[0]}</span>
                    <span>Rs. {tempValues[1]}</span>
                  </div>
                  <div className="d-flex justify-content-center align-items-center py-2">
                    <button
                      style={{
                        fontSize: "16px",
                        width: "100%",
                        background: "none",
                        border: "2px solid green",
                        color: "green",
                        borderRadius: "5px",
                      }}
                      onClick={handleClickApply}
                    >
                      Apply
                    </button>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-2 justify-content-center mt-3">
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    Sort by
                  </p>
                  <button
                    type="button"
                    style={{
                      border: "1px solid black",
                      fontSize: "14px",
                      padding: " 2px 5px",
                      borderRadius: "50px",
                    }}
                    className={`${
                      sortByAlphabatically ? "bg-primary text-white" : ""
                    }`}
                    onClick={() =>
                      setSortByAlphabatically(!sortByAlphabatically)
                    }
                  >
                    Alphabetically
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          className="resp-filters"
          data-bs-toggle="offcanvas"
          href="#offcanvasExample"
          role="button"
          aria-controls="offcanvasExample"
        >
          <BsSliders size={25} />
        </div>
        {/* <ResponsiveFilterSection /> */}
        <ResponsiveFilterSection
          setSelectedCategory={setSelectedCategory}
          setCurrentProducts={setCurrentProducts}
          setNavigatedCategory={setNavigatedCategory}
          scheme={scheme}
          setScheme={setScheme}
          categories={categories}
          colors={colors}
          sizes={sizes}
          brands={brands}
          stockStatus={stockStatus}
          setStockStatus={setStockStatus}
          sortByAlphabatically={sortByAlphabatically}
          setSortByAlphabatically={setSortByAlphabatically}
        />
      </div>
    </div>
  );
};

export default SortMenuComponent;
